const LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Research", href: "#research" },
  { label: "Team", href: "#team" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  const onClick = (href) => (e) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 pt-20 md:pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-2.5 h-2.5 bg-white block" />
              <span className="font-heading text-lg tracking-tight font-medium">
                Noeton Labs Inc.
              </span>
            </div>
            <p className="max-w-md text-[15px] text-zinc-400 leading-relaxed font-light">
              Research-driven foundations for sensing, modeling, optimization,
              machine learning, and intelligent decision support.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500 mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={onClick(l.href)}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-zinc-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500 mb-5">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li>
                <a
                  href="mailto:info@noetonlabsinc.ca"
                  className="hover:text-white transition-colors"
                >
                  info@noetonlabsinc.ca
                </a>
              </li>
              <li className="text-zinc-400">Canada</li>
            </ul>
          </div>
        </div>

        <div className="relative">
          <div
            aria-hidden
            className="pointer-events-none select-none font-heading tracking-tighter leading-none text-white/[0.04]"
            style={{ fontSize: "clamp(72px, 18vw, 260px)" }}
          >
            NOETON
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-wrap items-center justify-between gap-4">
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500">
            © {year} Noeton Labs Inc. All rights reserved.
          </div>
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500">
            Canada · R&amp;D
          </div>
        </div>
      </div>
    </footer>
  );
}
